import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';

const PrivacyPage = () => {
  // ΣΩΣΤΟ: Το hook καλείται ΜΕΣΑ στη συνάρτηση του component!
  useSEO({
    title: 'Πολιτική Απορρήτου - TailClinic',
    description: 'Ενημερωθείτε για το πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τα προσωπικά σας δεδομένα στο TailClinic, με απόλυτο σεβασμό στον κανονισμό GDPR.',
    canonical: 'https://www.tailclinic.gr/privacy',
  });

  return (
    <div style={{ backgroundColor: '#1A202C', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      <main style={{ padding: '6rem 0', position: 'relative', overflow: 'hidden', flex: 1 }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.12), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.06), transparent)' }} />
        
        <Container>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '4rem', position: 'relative' }}>
            <div style={{
              display: 'inline-block',
              padding: '0.35rem 1rem',
              borderRadius: '9999px',
              fontSize: '0.85rem',
              fontWeight: 700,
              color: '#10B981',
              backgroundColor: 'rgba(16,185,129,0.1)',
              border: '1px solid rgba(16,185,129,0.2)',
              marginBottom: '1.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              ΝΟΜΙΚΑ & GDPR
            </div>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1.25rem',
              letterSpacing: '-0.02em'
            }}>
              Πολιτική Απορρήτου
            </h1>
            <p style={{
              fontSize: '1.15rem',
              color: '#9CA3AF',
              maxWidth: '800px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Η ιδιωτικότητα και η προστασία των προσωπικών δεδομένων είναι υψίστης σημασίας για το <span style={{ color: '#10B981', fontWeight: '600' }}>TailClinic</span>. Η παρούσα πολιτική περιγράφει πώς προστατεύουμε τα δεδομένα σας.
            </p>
          </div>

          {/* Content Card */}
          <div style={{ 
            background: 'linear-gradient(135deg, rgba(16,185,129,0.25), rgba(59,130,246,0.15))', 
            borderRadius: '1.5rem', 
            padding: '1px',
            maxWidth: '950px',
            margin: '0 auto',
            boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
          }}>
            <div style={{
              backgroundColor: '#1F2937',
              borderRadius: '1.5rem',
              padding: '3rem 4rem'
            }}>
              
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2.5rem',
                color: '#D1D5DB'
              }}>
                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>1.</span> Υπεύθυνος Επεξεργασίας
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Υπεύθυνος επεξεργασίας για την επεξεργασία των προσωπικών δεδομένων στο πλαίσιο του TailClinic είναι η εταιρεία <strong>[Επωνυμία Εταιρείας]</strong>. Για οτιδήποτε αφορά την επεξεργασία δεδομένων, μπορείτε να επικοινωνείτε στο support@tailclinic.gr.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>2.</span> Κατηγορίες Δεδομένων
                  </h2>
                  <ul style={{ paddingLeft: '1.5rem', lineHeight: 1.8, fontSize: '1.05rem', margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <li>Στοιχεία λογαριασμού (όνομα, email, κωδικός πρόσβασης).</li>
                    <li>Λειτουργικά δεδομένα χρήσης (IP, logs σύνδεσης, ρυθμίσεις).</li>
                    <li>Δεδομένα ραντεβού και πελατών που καταχωρούν οι κλινικές (η κλινική παραμένει ο Υπεύθυνος Επεξεργασίας αυτών).</li>
                    <li>Τεχνικά cookies για τη λειτουργία και την ασφάλεια της σύνδεσης.</li>
                  </ul>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>3.</span> Σκοποί & Νομικές Βάσεις
                  </h2>
                  <ul style={{ paddingLeft: '1.5rem', lineHeight: 1.8, fontSize: '1.05rem', margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <li>Παροχή υπηρεσίας και λειτουργιών λογαριασμού (εκτέλεση σύμβασης).</li>
                    <li>Ασφάλεια, πρόληψη κακής χρήσης και αποτροπή απάτης (έννομο συμφέρον/νομική υποχρέωση).</li>
                    <li>Εξυπηρέτηση πελατών και επικοινωνία (εκτέλεση σύμβασης).</li>
                  </ul>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>4.</span> Διατήρηση & Διαγραφή Δεδομένων
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Τα δεδομένα διατηρούνται μόνο για όσο απαιτείται για τους ανωτέρω σκοπούς. Ο χρήστης μπορεί να ζητήσει την <strong>οριστική διαγραφή</strong> του λογαριασμού και των δεδομένων του ανά πάσα στιγμή. Δεν υποστηρίζεται εξαγωγή (export) σε εξωτερικά αρχεία.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>5.</span> Κοινοποιήσεις σε Τρίτους
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Ενδέχεται να κοινοποιούμε δεδομένα σε παρόχους υπηρεσιών που ενεργούν ως Εκτελούντες την Επεξεργασία (φιλοξενία, email, πληρωμές), βάσει συμβάσεων επεξεργασίας και με κατάλληλα μέτρα ασφαλείας. Οι servers μας βρίσκονται εντός ΕΕ.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>6.</span> Cookies & Ιχνηλάτες
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Ο ιστότοπος χρησιμοποιεί <strong>αποκλειστικά και μόνο τεχνικά/απαραίτητα cookies</strong> (session cookies) που είναι αναγκαία για την ασφαλή σύνδεση των χρηστών. Δεν χρησιμοποιούμε cookies διαφήμισης, ανάλυσης συμπεριφοράς ή τρίτων μερών, και ως εκ τούτου δεν απαιτείται συγκατάθεση χρήστη (banner).
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>7.</span> Δικαιώματα Υποκειμένων
                  </h2>
                  <ul style={{ paddingLeft: '1.5rem', lineHeight: 1.8, fontSize: '1.05rem', margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <li>Πρόσβαση, διόρθωση, διαγραφή (δικαίωμα στη λήθη).</li>
                    <li>Περιορισμός και εναντίωση στην επεξεργασία.</li>
                  </ul>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem', marginTop: '0.5rem' }}>
                    Για την άσκηση των δικαιωμάτων σας, επικοινωνήστε στο support@tailclinic.gr. Διατηρείτε το δικαίωμα καταγγελίας στην ΑΠΔΠΧ.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>8.</span> Ασφάλεια
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Εφαρμόζουμε τεχνικά και οργανωτικά μέτρα ασφαλείας (κρυπτογράφηση, ελέγχους πρόσβασης, καταγραφή συμβάντων) για την προστασία των δεδομένων από μη εξουσιοδοτημένη πρόσβαση, αλλοίωση ή απώλεια.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>9.</span> Ανηλίκοι
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Οι υπηρεσίες μας απευθύνονται σε άτομα άνω των 18 ετών. Εάν διαπιστωθεί χρήση από ανήλικο χωρίς νόμιμη συγκατάθεση, ενδέχεται να αναστείλουμε την πρόσβαση και να διαγράψουμε τα σχετικά δεδομένα.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>10.</span> Ενημερώσεις της Πολιτικής
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Η παρούσα πολιτική μπορεί να ενημερώνεται περιοδικά. Σημαντικές αλλαγές θα γνωστοποιούνται μέσω του ιστότοπου ή/και με ειδοποιήσεις εντός της εφαρμογής. Η συνέχιση χρήσης της υπηρεσίας συνεπάγεται αποδοχή της ενημερωμένης πολιτικής.
                  </p>
                </section>

                {/* Footer of the card */}
                <div style={{ 
                  marginTop: '1rem', 
                  paddingTop: '2rem', 
                  borderTop: '1px solid #374151', 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '1rem'
                }}>
                  <div style={{ fontSize: '0.9rem', color: '#9CA3AF' }}>
                    Τελευταία ενημέρωση: <strong>Φεβρουάριος 2026</strong>
                  </div>
                  <div style={{ fontSize: '0.9rem', color: '#9CA3AF' }}>
                    Επικοινωνία DPO: <a href="mailto:support@tailclinic.gr" style={{ color: '#10B981', textDecoration: 'none', fontWeight: '600' }}>support@tailclinic.gr</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;